module.exports = __webpack_public_path__ + "img/widgets7.f01670fa.png";